<!--
 * @Author: Oliver
 * @Date: 2025-03-28 11:13:56
 * @LastEditors: Oliver
 * @LastEditTime: 2025-04-01 15:19:05
 * @FilePath: /kepler/src/layout/components/AppMain.vue
-->
<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
    <!-- 上传至阿里云组件 -->
    <global-up />
  </section>
</template>

<script>
import globalUp from "@/components/globalUp/index.vue";
export default {
  name: "AppMain",
  components: { globalUp },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
  methods: {
    collapseUploader() {
      this.$store.dispatch("tagsView/delView", this.$route);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
